import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import type { IconType } from '../../types';

const IconName = 'Comment';

const IconSvg = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.4423 16.3052C8.71935 16.1943 9.0232 16.1685 9.31499 16.2311C10.1391 16.4081 11.0424 16.5 12 16.5C14.286 16.5 16.2079 15.9787 17.5115 15.0783C18.7568 14.2181 19.5 12.9809 19.5 11.25C19.5 9.51912 18.7568 8.28194 17.5115 7.42169C16.2079 6.52126 14.286 6 12 6C9.71404 6 7.79212 6.52126 6.48855 7.42169C5.24316 8.28194 4.5 9.51912 4.5 11.25C4.5 12.5573 4.9229 13.5531 5.61309 14.3171C6.16363 14.9266 6.59045 15.554 6.76809 16.3132C6.81836 16.5281 6.84454 16.7382 6.8538 16.9414L8.4423 16.3052ZM4.5 19.5C4.5 19.5 5.12598 18.6431 5.25 18C5.28065 17.8411 5.30655 17.6934 5.32531 17.5536C5.43241 16.7555 5.30652 16.2155 4.5 15.3226C3.55223 14.2734 3 12.9159 3 11.25C3 6.75 7.02944 4.5 12 4.5C16.9706 4.5 21 6.75 21 11.25C21 15.75 16.9706 18 12 18C10.9481 18 9.93834 17.8992 9 17.6977L4.5 19.5Z" fill="currentColor"/>
  </svg>
`;

const CommentIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.4423 16.3052C8.71935 16.1943 9.0232 16.1685 9.31499 16.2311C10.1391 16.4081 11.0424 16.5 12 16.5C14.286 16.5 16.2079 15.9787 17.5115 15.0783C18.7568 14.2181 19.5 12.9809 19.5 11.25C19.5 9.51912 18.7568 8.28194 17.5115 7.42169C16.2079 6.52126 14.286 6 12 6C9.71404 6 7.79212 6.52126 6.48855 7.42169C5.24316 8.28194 4.5 9.51912 4.5 11.25C4.5 12.5573 4.9229 13.5531 5.61309 14.3171C6.16363 14.9266 6.59045 15.554 6.76809 16.3132C6.81836 16.5281 6.84454 16.7382 6.8538 16.9414L8.4423 16.3052ZM4.5 19.5C4.5 19.5 5.12598 18.6431 5.25 18C5.28065 17.8411 5.30655 17.6934 5.32531 17.5536C5.43241 16.7555 5.30652 16.2155 4.5 15.3226C3.55223 14.2734 3 12.9159 3 11.25C3 6.75 7.02944 4.5 12 4.5C16.9706 4.5 21 6.75 21 11.25C21 15.75 16.9706 18 12 18C10.9481 18 9.93834 17.8992 9 17.6977L4.5 19.5Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default {
  name: IconName,
  title: IconName,

  IconComponent: CommentIcon,
  IconSvg: IconSvg
} as IconType;
